export const C_DOCUMENT_TYPE_DOU = 'document_type_dou'
export const C_DOCUMENT_TYPE_TEACHER = 'document_type_teacher'
